const specs = {
  width: 620,
  title: {
    update: 'pages.risks.modal.update.single.title',
    create: 'pages.risks.modal.create.single.title'
  },
  okText: {
    update: 'pages.risks.modal.update.single.okText',
    create: 'pages.risks.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.risks.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.risks.fields.name.title',
        required: 'pages.risks.fields.name.requiredMessage',
        placeholder: 'pages.risks.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
